import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import IsomorphicLink from 'corp/components/UI/IsomorphicLink';
import RemoAdminContext from 'react-scale/components/remoAdmin/remoAdminContext';

import { isScaleBot } from '@scale/shared/defaults';

interface ObjectIDFormatterProps {
  value?: string;
  customUrl?: string;
  customLabel?: string;
  target?: string;
}

const LookupLinkPrefixWrapper: React.FC<{ id: string; customUrl?: string; target?: string }> = ({
  id,
  customUrl,
  target,
}) => {
  const remoAdminCtx = useContext(RemoAdminContext);
  const lookupPrefix = remoAdminCtx.isRemoAdmin ? 'outlieradmin/tools/lookup' : 'lookup';
  return (
    <IsomorphicLink href={customUrl ?? `/${lookupPrefix}/${id}`} target={target}>
      <FontAwesomeIcon icon="external-link-alt" />
    </IsomorphicLink>
  );
};

const ObjectIDFormatter: React.FC<ObjectIDFormatterProps> = ({
  value,
  customLabel,
  customUrl,
  target,
}) => {
  if (!value) {
    return null;
  }

  return (
    <div className="cell">
      <div style={{ width: '6px', flexShrink: 0 }} />
      {isScaleBot(value) ? <div>Scale Bot</div> : <pre>{customLabel ?? value}</pre>}
      <LookupLinkPrefixWrapper id={value} customUrl={customUrl} target={target} />
      <style jsx>{`
        .cell {
          display: flex;
          align-items: center;
          justify-content: center;

          overflow: hidden;
        }

        .cell a {
          flex-shrink: 0;
        }

        .cell pre {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>
    </div>
  );
};

export default ObjectIDFormatter;
